<template>
    <div class="verification">
        <h5>区块链存证信息核验</h5>
        <div class="head">
            <p class="row">资产名称: {{ data.propertyname }}</p>
            <p class="row">资产ID: {{ data.propertyId }}</p>
            <p class="row">所有者: {{ data.nickname }}</p>
            <div class="row">
                <p>存证哈希值: {{ data.certifDateHash }}</p>
                <span class="btn" @click="copyToClipboard(data.certifDateHash)">复制</span>
            </div>
            <div class="row">
                <p>区块链地址: {{ data.txId }}</p>
                <span class="btn" @click="copyToClipboard(data.txId)">复制</span>
            </div>
            <p class="btn row" @click="checkCertifcation()">资产存证证书</p>
            <p class="btn row" @click="checkCertifcation()">资产存证报告</p>
        </div>
        <div v-for="item in data.userDoList" class="item">
            <p class="row">存证类型: {{ item.certifType }}</p>
            <p class="row">存证时间: {{ item.createTime }}</p>
            <p class="row">区块高度: {{ item.height }}</p>
            <div class="row">
                <p>{{ item.certifDateHash }}</p>
                <span class="btn" @click="copyToClipboard(item.certifDateHash)">复制</span>
            </div>
            <div class="row">
                <p>{{ item.txId }}</p>
                <span class="btn" @click="copyToClipboard(item.txId)">复制</span>
            </div>
        </div>
    </div>

    <van-dialog v-model:show="showDialog" :showCancelButton="true" title="资产存证证书" @confirm="downloadPDF()"
        confirm-button-text="下载">
        <div class="dialog_content">
            <h4>数字资产区块链存证证书</h4>
            <section>
                <p class="row">资产名称: {{ certifReport.modelName }}</p>
                <p class="row">资产展示图: <img :src="certifReport.imageUrl" alt=""></p>
                <p class="row">数据大小: {{ certifReport.modelSize }}</p>
                <div class="row">
                    <p>资产哈希值: {{ certifReport.modelHash }}</p>
                    <span class="btn" @click="copyToClipboard(certifReport.modelHash)">复制</span>
                </div>
                <p class="row">所有者: {{ certifReport.belongUserName }}</p>
                <div class="row">
                    <p>存证编码: {{ certifReport.certificateNo }}</p>
                    <span class="btn" @click="copyToClipboard(certifReport.certificateNo)">复制</span>
                </div>
                <p class="row">存证时间: {{ certifReport.certificateTime }}</p>
                <div class="row">
                    <p>区块链地址: {{ certifReport.chainHash }}</p>
                    <span class="btn" @click="copyToClipboard(certifReport.chainHash)">复制</span>
                </div>
            </section>
            <ul>
                <li v-for="item in certifReport.storageEvidenceList" :key="item.storageEvidenceId">
                    <p class="row">存证类型: {{ item.depositType }}</p>
                    <p class="row">存证时间: {{ item.depositTime }}</p>
                    <div class="row">
                        <p>存证哈希值: {{ item.depositHash }}</p>
                        <span class="btn" @click="copyToClipboard(item.depositHash)">复制</span>
                    </div>
                </li>
            </ul>
        </div>
    </van-dialog>


</template>
<script setup>
import { http } from '@/request/http'
import { onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { copyToClipboard } from '@/utils/util.js';


const route = useRoute(), router = useRouter()
const data = reactive({
    "type": 2,
    "userId": 318,
    "propertyId": 1543,
    "nickname": "东方数科",
    "propertyname": "九鱼聚财图",
    "certifDateHash": "faa9e3aa7f2b82a4a4069cc97cd489633bea09b7ad6eca683f4528557e643b7c",
    "certifDate": null,
    "txId": "18b3966436f29656cafdc9e74f3a0cba86ababf8576f48289524bf884f5f14c7",
    "height": "979",
    "propertyCount": null,
    "selfs": 1,
    "modelsCertifId": 318,
    "userDoList": []
})
onMounted(() => {
    http.get('/app-api/member/certifInfo/list?txId=' + route.query.keyword).then(res => {
        Object.assign(data, res)
    })
})
const certifReport = reactive({
    storageEvidenceList: []
})
const showDialog = ref(false)
function checkCertifcation() {
    http.get('/app-api/member/contract/getCertificateReportJson?modelId=' + data.propertyId).then(res => {
        console.log(res)
        Object.assign(certifReport, res)
        showDialog.value = true
    })
}
function downloadPDF() {
    http.get('/app-api/member/contract/getContractUrl?templateName=Assrt.ftl&businessId=' + data.propertyId).then(res => {
        window.open(res.fileUrl)
    })
}

</script>
<style scoped lang="scss">
.verification {
    padding: 20rem;
    background-color: #fff;

    >h5 {
        text-align: center;
        margin-bottom: 20rem;
        font-size: 20rem;
    }

    .head {}

    .item {
        background-color: #eee;
        padding: 10rem;
        margin: 10rem 0;
    }
}

.row {
    // height: 30rem;
    line-height: 30rem;
    // display: flex;
    // justify-content: space-between;
    font-size: 12rem;
    img {
        height: 100rem;
    }

    p {
        // white-space: nowrap;
        // width: 90%;
        font-size: 12rem;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.btn {
    color: #409eff;
}

.dialog_content {
    padding: 20rem;
    height: 70vh;
    overflow-y: scroll;
    background-color: #fff;

    h4 {
        margin: 20rem 0;
        text-align: center;
    }

    ul {
        li {
            margin-bottom: 20rem;
            background-color: #eee;
            padding: 10rem;

            p {
                overflow: hidden;
            }
        }
    }

}
</style>